import { AxiosInstance } from 'axios'
import { useKeycloak } from 'hooks/useKeyKloak'

type Props = {
  axiosInstances?: AxiosInstance[]
}

function AxiosInstanceTokenInjector({ axiosInstances }: Props) {
  const { keycloak } = useKeycloak()

  if (axiosInstances && axiosInstances.length > 0) {
    axiosInstances?.forEach((axios) => {
      if (keycloak?.token) {
        axios.defaults.headers.common['Authorization'] =
          'Bearer ' + keycloak?.token
      } else {
        delete axios.defaults.headers.common['Authorization']
      }
    })
  }

  return null
}

export default AxiosInstanceTokenInjector
